import { classicBusinessProjectFormSubmitRoute } from '@jira/router-routes__business-form-routes/src/classicBusinessProjectFormSubmitRoute.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { formSubmitPageEntrypoint } from './ui/form-submit/index.tsx';

export const classicBusinessProjectFormSubmitRouteEntry: Route = createEntry(
	classicBusinessProjectFormSubmitRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.form-submit-view',
		layout: chromelessLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: getProjectViewResources(),
		entryPoint: () => formSubmitPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
